module.exports = __webpack_public_path__ + "img/618093735238824_image.jpg";